import { defineComponent as _defineComponent } from 'vue'
import { computed, inject } from 'vue';
import { useRoute } from 'vue-router/composables';
import SettingsMenu from '@/pages/settings/settings-menu.vue';
import AuthService from '@/account/auth.service';
import MandantService from '@/account/mandant.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'jhi-navbar',
  props: {
  mandantId: {
    type: Number,
    default: -1,
  },
  admin: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props;



const route = useRoute();

const mandantInfo = computed(() => mandantService().extractMandant(props.mandantId));

const authService = inject<() => AuthService>('authService');
const mandantService = inject<() => MandantService>('mandantService');

const isAdmin = computed(() => props.admin);
const authenticated = authService().isAuthenticated();

const subIsActive = input => {
  const paths = Array.isArray(input) ? input : [input];
  return paths.some(path => route.path.startsWith(path));
};

const logout = () => {
  authService().logout();
};

return { __sfc: true,props, route, mandantInfo, authService, mandantService, isAdmin, authenticated, subIsActive, logout, SettingsMenu }
}

})